import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../../auth/auth-provider/auth-provider"
import GetPfofileTradingConfigByProfileCode from "../../api-layer/profile-trading-config-api/GetProfileTradingConfigByProfileCode";

const ProfileTradingConfigContext = createContext(null);


const ProfileTradingConfigProvider = ({children}) => {
    const auth = useAuth();

    const [profileTradingConfig, setProfileTradingConfig] = useState(null);

    useEffect(() => {
        getConfig();
    },
    [
    ]);

    const getConfig = async () => {
        try {
            const response = await GetPfofileTradingConfigByProfileCode(auth?.user?.profileCode);
            setProfileTradingConfig(response.data);
        } catch(error) {
            // console.log('erroir in get pconf: ', error);
        }
    }

    const getConfigByProfileCode = async (profileCode) => {
        try {
            return await GetPfofileTradingConfigByProfileCode(profileCode);
        } catch(error) {
            throw error;
        }
    }

    return (
        <ProfileTradingConfigContext.Provider
            value={{
                profileTradingConfig,
                getConfigByProfileCode,
            }}
        >
            {children}
        </ProfileTradingConfigContext.Provider>
    );
}

export default ProfileTradingConfigProvider

export const useProfileTradingConfig = () => {
    return useContext(ProfileTradingConfigContext);
}